// src/app/slices/disconnectSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteAccessory } from './actions';
import { AccessoryState, IDisconnect, IDisconnectParams } from '../models';

const initialState: AccessoryState<IDisconnect, IDisconnectParams> = {
  accessories: {},
  params: null,
};

const disconnectSlice = createSlice({
  name: 'disconnect',
  initialState,
  reducers: {
    setDisconnect: (state, action: PayloadAction<IDisconnect>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setDisconnectParams: (state, action: PayloadAction<IDisconnectParams>) => {
      state.params = action.payload;
    },
    deleteDisconnect: deleteAccessory,
  },
});

export const { setDisconnect, setDisconnectParams, deleteDisconnect } =
  disconnectSlice.actions;

export default disconnectSlice.reducer;
